export interface SquareTileDescriptionProps{
    description:string
}
export function SquareTileDescription (props:SquareTileDescriptionProps){
    return <>
    {props.description}
    </>
}